import { Controller } from '@hotwired/stimulus';
import { EVENTO_CONTROLLER_CARGADO } from '../application_controller';

/* global $, cloneOnScroll */
export default class extends Controller {
  connect() {
    this.$element = $(this.element);
    // Esto no está bien pero lo traigo tal cual estaba
    this.$element.on('change', '[id^=ge_sus_recibos]', function cambiaCheck() {
      const $meses = $('.servicios-alumnos-filtro-meses-wrapper');
      if ($(this).is(':checked')) {
        $meses.removeClass('hide');
      }
    });
    $(window).on('scroll', () => {
      this.#clonarCabecerasTablaOnScroll();
    });

    const $listado = this.$element.find('[data-controller=listado]');

    $listado.on('listado:updated', () => {
      this.#clonarCabecerasTablaOnScroll();
      this.#gestionAsignarFechaFin();
    });
    this.#gestionAsignarFechaFin();
  }

  /* eslint-disable class-methods-use-this */
  #clonarCabecerasTablaOnScroll() {
    // TODO: No usar esta función global, esto habrá que migrarlo a una clase JS
    cloneOnScroll($(window), $(document.body), '#listado-ge', '#wrapper-gestion-economica', '#wrapper-gestion-economica', false);
  }

  #gestionAsignarFechaFin() {
    const $boton = this.$element.find('#btn-asignar-fecha-fin');
    // Cuando cargue el modal-html asignamos datos
    $boton.on(EVENTO_CONTROLLER_CARGADO, (e) => {
      const { controller } = e.detail;
      controller.urlParams(() => {
        const botonSeleccionarTodo = window.Stimulus.getControllerForElementAndIdentifier(
          $('#boton-marcar-suscripciones')[0], 'seleccionar-todo',
        );
        return botonSeleccionarTodo ? botonSeleccionarTodo.getParametrosFiltros() : {};
      });
    });
    $boton.cifra_btn_toggle_selected();
  }
}
